var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7085 2.66333L22.7485 20.01H2.66849L12.7085 2.66333ZM0.361828 18.6767C-0.664838 20.45 0.615161 22.6767 2.66849 22.6767H22.7485C24.8018 22.6767 26.0818 20.45 25.0552 18.6767L15.0152 1.33C13.9885 -0.443333 11.4285 -0.443333 10.4018 1.33L0.361828 18.6767ZM11.3752 9.34333V12.01C11.3752 12.7433 11.9752 13.3433 12.7085 13.3433C13.4418 13.3433 14.0418 12.7433 14.0418 12.01V9.34333C14.0418 8.61 13.4418 8.01 12.7085 8.01C11.9752 8.01 11.3752 8.61 11.3752 9.34333ZM11.3752 16.01H14.0418V18.6767H11.3752V16.01Z",
    fill: "#BA0517"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.a9857c92e85c785dc2bfd889f9f4b30f.svg";
export { ForwardRef as ReactComponent };